var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChatMsgIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#DEEEFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 10H15C12.24 10 10 12.23 10 14.98V20.96V21.96C10 24.71 12.24 26.94 15 26.94H16.5C16.77 26.94 17.13 27.12 17.3 27.34L18.8 29.33C19.46 30.21 20.54 30.21 21.2 29.33L22.7 27.34C22.89 27.09 23.19 26.94 23.5 26.94H25C27.76 26.94 30 24.71 30 21.96V14.98C30 12.23 27.76 10 25 10ZM21 21.75H15C14.59 21.75 14.25 21.41 14.25 21C14.25 20.59 14.59 20.25 15 20.25H21C21.41 20.25 21.75 20.59 21.75 21C21.75 21.41 21.41 21.75 21 21.75ZM25 16.75H15C14.59 16.75 14.25 16.41 14.25 16C14.25 15.59 14.59 15.25 15 15.25H25C25.41 15.25 25.75 15.59 25.75 16C25.75 16.41 25.41 16.75 25 16.75Z",
    fill: "#0473EA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatMsgIcon);
export default __webpack_public_path__ + "static/media/chat-msg-icon.bf3eeb446b87ed53fd1834a217afb9d3.svg";
export { ForwardRef as ReactComponent };